
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 7c3.302 0 6 2.698 6 6 0 1.984-.975 3.75-2.469 4.844A8.06 8.06 0 0115 21.125a8.048 8.048 0 013.469-3.281A6.003 6.003 0 0116 13c0-3.302 2.698-6 6-6s6 2.698 6 6c0 1.984-.975 3.75-2.469 4.844C28.169 19.154 30 21.864 30 25h-2c0-3.326-2.674-6-6-6s-6 2.674-6 6h-2c0-3.326-2.674-6-6-6s-6 2.674-6 6H0c0-3.136 1.831-5.846 4.469-7.156A6.003 6.003 0 012 13c0-3.302 2.698-6 6-6zm0 2c-2.221 0-4 1.779-4 4s1.779 4 4 4 4-1.779 4-4-1.779-4-4-4zm14 0c-2.221 0-4 1.779-4 4s1.779 4 4 4 4-1.779 4-4-1.779-4-4-4z"}})])
          )
        }
      }
    